export const userUpdate = (user) =>  {
    return {
        type: 'USER_LOGIN',
        user
    }
}

export const logout = () => {
    return {
        type: 'USER_LOGOUT'
    }
}



// WEBPACK FOOTER //
// ./src/actions/auth.js